import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { URLSearchParams } from '@angular/http';
import { Api } from './api.service';
import { PAGINATION_NUMBER } from './constants.service';
import { SimpleCrudInterface } from './crud.interface';
import { WhiteLabelService} from './white-label.service';
import { Retailer, ListResult } from '../entities/index';
import { Log } from '../utils/index';
import { RetailerShort, RetailerShortResponse } from '../entities/retailer.entity';

@Injectable()
export class RetailerService implements SimpleCrudInterface<RetailerShort> {
  retailers: Promise<RetailerShort[]>;
  dataStore: RetailerShort[] = [];

  constructor(
    protected http: Api,
    protected whiteLabelService: WhiteLabelService
  ) {}

  @Log('green')
  list(search: string = null, page: number = 1, limit: number = PAGINATION_NUMBER): Observable<ListResult<Retailer>> {
    const params = new URLSearchParams();
    if (search) {
      params.set('search', search);
    }
    return this.http.get('retailer', {search: params});
  }

  getAll(forceReload: boolean = false): Promise<RetailerShort[]> {
    if (!this.retailers || forceReload) {
      const params = new URLSearchParams();
      params.set('limit', '3000');
      params.set('sort_order', 'asc');
      params.set('sort_field', 'name');

      this.retailers = this.http.get('retailers', { search: params }).toPromise().then((res: RetailerShortResponse) => {
        return this.dataStore = res.items;
      });
    }

    return this.retailers;
  }

  @Log('green')
  create(retailer: Retailer): Observable<Retailer> {
    // white_label object is only present in retailer object for convenience in display.
    // It should not be contained in requests.
    if (retailer.white_label) {
      delete retailer.white_label;
    }
    return this.http.post('retailer', retailer);
  }

  @Log('green')
  update(retailer: Retailer): Observable<Retailer> {
    const retailerId = retailer.id;
    // white_label object is only present in retailer object for convenience in display.
    // It should not be contained in requests.
    if (retailer.white_label) {
      delete retailer.white_label;
    }
    return this.http.put(`retailer/${retailerId}`, retailer);
  }

  save(retailer: Retailer): Observable<Retailer> {
    const isNew = undefined === retailer.id;
    if (isNew) {
      return this.create(retailer);
    } else {
      return this.update(retailer);
    }
  }

  @Log('green')
  remove(retailer: Retailer): Observable<Response> {
    const retailerId = retailer.id;
    return this.http.delete(`retailer/${retailerId}`);
  }

  /**
   * Used to display white_label's code on retailers list from their white_label_id attribute
   * The white_label MUST be removed from POST and PUT requests as it's not a database attribute of the retailer class.
   */
  _find_white_label(retailers: Retailer[]): Retailer[] {
      retailers.forEach(retailer => {
        if (retailer.white_label_id) {
          this.whiteLabelService.get(retailer.white_label_id)
            .subscribe((whiteLabel) => retailer.white_label = whiteLabel);
        }
      });
      return retailers;
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/services/retailer.service.ts